import { render, staticRenderFns } from "./InventoryWip.vue?vue&type=template&id=55fd66fa&"
import script from "./InventoryWip.vue?vue&type=script&lang=js&"
export * from "./InventoryWip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports